import './SubmissionError.scss';
import { ReactComponent as Warning } from 'assets/warning.svg';

const SubmissionError = () =>{
  return (
      <div>
        <div className="submission-error-page">
          <div className=" logo-size"><Warning/></div>
          <div className="error-title">We are having technical issues submitting your request.</div>
          <div className="error-content">We apologize for the inconvenience. If you would like assistance by phone, please <a className="error-link"
                                                                                                                              rel="noreferrer noopener"
                                                                                                                              href="https://www.troweprice.com/personal-investing/help/contact-us.html">contact us.</a></div>
        </div>
      </div>
  );
}

export default SubmissionError;